import { useAuthorization } from 'components/Authorization';
import { flatMap, filter, orderBy, toNumber } from 'lodash-es';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { TodoListMap } from 'views/Conversation/Sider/ToDoBundle/state';

const badgeType = atom<'red' | 'blue' | undefined>();

const chatHeaderTodoInstance = atom<Todo.TodoInstance | undefined>();

export const useSetSiderTodoBadge = () => useSetAtom(badgeType);
export const useSiderTodoBadge = () => useAtomValue(badgeType);

export const useChatHeaderTodoInstance = () => useAtomValue(chatHeaderTodoInstance);
export const useSetChatHeaderTodoInstance = () => useSetAtom(chatHeaderTodoInstance);
export const useClearChatHeaderTodoInstance = () => {
  const setChatHeaderTodoInstance = useSetChatHeaderTodoInstance();
  return () => {
    setChatHeaderTodoInstance(undefined);
  };
};

const isTodoNotClosed = (todoStatus: Todo.Status) => {
  return todoStatus !== 3;
};

export const useUpdateSiderTodoBadge = () => {
  const setBadgeType = useSetSiderTodoBadge();
  const setChatHeaderTodoInstance = useSetChatHeaderTodoInstance();
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  /**
   * PD: https://leyan.yuque.com/czpqnb/pd/zkqlen4644lzpsg5#y7JtO
   * - 若当前会话存在至少一个未关闭的待办项，受理客服为当前子账号或者为空。
   *    侧边栏-待办显示红点。
   * - 若当前会话存在未关闭待办项，且所有待办项的受理客服均为其他子账号
   *    侧边栏-待办显示蓝点。
   */
  return function updateSiderTodoBadge(todoListMap: TodoListMap) {
    const unclosedTodoInstances = flatMap(todoListMap, (todoInstances) => {
      return filter(todoInstances, (todo) => isTodoNotClosed(todo.todoStatus));
    });

    if (unclosedTodoInstances.length > 0) {
      const isAllOther = unclosedTodoInstances.every(
        ({ operator }) => operator && operator !== '0' && operator !== payload?.id.toString(),
      );
      if (isAllOther) {
        setBadgeType('blue');
        const filtered = orderBy(
          filter(unclosedTodoInstances, ({ operator }) => !!operator),
          ({ createTime }) => toNumber(createTime),
          'desc',
        );
        setChatHeaderTodoInstance(filtered[0]);
      } else {
        setBadgeType('red');
        const filtered = orderBy(
          filter(
            unclosedTodoInstances,
            ({ operator }) => !operator || operator === '0' || operator === payload?.id.toString(),
          ),
          ({ createTime }) => toNumber(createTime),
          'desc',
        );
        setChatHeaderTodoInstance(filtered[0]);
      }
    } else {
      setBadgeType(undefined);
      setChatHeaderTodoInstance(undefined);
    }
  };
};
